import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { CommonService } from '../../../services/common.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import moment from 'moment';

declare var jquery: any;
declare var $: any;

@Component({
    selector: 'app-nomenclature-nego',
    templateUrl: './nomenclature-nego.component.html',
    styleUrls: ['./nomenclature-nego.component.css'],
    standalone: false
})
export class NomenclatureNegoComponent implements OnInit {
  @Input() detail;
  @Input() edit: Boolean;
  @Input() add: Boolean;
  @Output() show = new EventEmitter<any>();

  selected = [];
  dataArticle = [];
  isEmpty: Boolean = true;
  renderTable: Boolean = true;
  isEdit: Boolean = false;
  isFamille2: Boolean = false;
  default = 0;
  nbdigit;
  classPresta: String = 'detailfact ';
  adresseAchat: Boolean = false;
  devise;
  pays = '';
  articleLigneVide: Boolean = false
  focusIndex = 0;
  listExutoire: any = [{ id: 0, libelle: 'Tous', libelleObjetEntite: 'Tous' }];
  typeContenant: any = [{ id: 0, libelle: 'Tous', libelleObjetEntite: 'Tous' }];
  artContenu: any = [{ id: 0, libelle: 'Tous', libelleObjetEntite: 'Tous' }];
  listChantier = [{ id: 0, libelleObjetEntite: 'Tous' }];
  listeAgence = [{ id: 0, libelleObjetEntite: 'Toutes' }];

  listNomenclature = [];
  selectedRow: any = {};
  erreur = '';
  @ViewChild('msg') msg;
  rowIndexEdit = 0;

  constructor(public common: CommonService, private modalService: BsModalService) {
    this.nbdigit = this.common.local.getObject('paramSociete').nbDigitDevise;
    this.devise = this.common.local.getObject('paramSociete').devise;
    this.adresseAchat = this.common.local.getObject('paramSociete').adresseAchat;
  }

  ngOnInit() {
    this.getListNomenclature().then(data => {
      this.isEmpty = false;
    });
  }

  hide() {
    this.show.emit();
  }

  showFormEdit(row) {
    this.selectedRow = Object.assign({}, row);
    if (this.selectedRow.id) {
      this.checkFamilleArt(this.selectedRow.id);
      row.edit = true;
      this.selectedRow.add = false;
    } else {
      this.selectedRow.add = true;
    }
    this.selectedRow.articleContenu = this.selectedRow.articleContenu || this.artContenu[0];
    this.selectedRow.typeContenant = this.selectedRow.typeContenant || this.typeContenant[0];
    this.selectedRow.chantier = this.selectedRow.chantier || this.listChantier[0];
    this.selectedRow.agence = this.selectedRow.agence || this.listeAgence[0];
    this.selectedRow.exu = this.selectedRow.exu || this.listExutoire[0];
    this.isEdit = !this.isEdit;
    if (this.isEdit) {
      this.getListeAgence();
      this.searchTypecontenant();
    }
  }

  validerFormEdit() {
    const temp = [];
    this.selectedRow.listArtNomenclature = this.selectedRow.listArtNomenclature || [];
    const obj = Object.assign({}, this.selectedRow);
    obj.articleContenu = obj.articleContenu || { id: 0 };
    obj.typeContenant = obj.typeContenant || { id: 0 };
    obj.chantier = obj.chantier || { id: 0 };
    obj.agence = obj.agence || { id: 0 };
    obj.exu = obj.exu || { id: 0 };
    const existe = this.listNomenclature.filter((elt, index) => {
      elt.articleContenu = elt.articleContenu || { id: 0 };
      elt.typeContenant = elt.typeContenant || { id: 0 };
      elt.chantier = elt.chantier || { id: 0 };
      elt.agence = elt.agence || { id: 0 };
      elt.exu = elt.exu || { id: 0 };
      return (obj.id === elt.id
      && (obj.articleContenu.id === elt.articleContenu.id)
      && (obj.typeContenant.id === elt.typeContenant.id)
      && (obj.chantier.id === elt.chantier.id)
      && (obj.agence.id === elt.agence.id)
      && (obj.exu.id === elt.exu.id)
      && (!elt.edit))
    });

    if (existe && existe.length) {
      this.erreur = `L\'article sélectionné existe déjà dans la liste.`;
      this.common.openModal(this.modalService, this.msg);
    } else {
      this.verificationLigne(0);
    }
  }

  verificationLigne(index) {
    if (index < this.selectedRow.listArtNomenclature.length) {
      const elt = this.selectedRow.listArtNomenclature[index];
      const filter = this.selectedRow.listArtNomenclature.filter(e => e.id === elt.id);

      if (filter && filter.length > 1) {
        this.erreur = `L\'article : "${elt.libelle ? elt.libelle : ''}" existe déjà dans la liste.`;
        this.common.openModal(this.modalService, this.msg);
      } else {
        this.verificationLigne(index + 1);
      }
    } else {
      const temp = [];
      this.articleLigneVide = false;
      this.selectedRow.listArtNomenclature.forEach(element => {
        if (element.id) {
        } else {
          this.articleLigneVide = true;
        }
      });

      if (this.articleLigneVide) {
        this.erreur = `Champs article obligatoire`;
        this.common.openModal(this.modalService, this.msg);
        return false;
      }
      if (this.selectedRow.id && this.selectedRow.id > 0) {
        if (this.selectedRow.add && this.rowIndexEdit < 0) {
          this.listNomenclature.push(this.selectedRow);
          this.selectedRow.edit = false;
          this.listNomenclature = [...this.listNomenclature];
        } else {
          this.listNomenclature.forEach((elt, idx) => {
            if (elt.id === this.selectedRow['id'] && idx === this.rowIndexEdit) {
              elt = this.selectedRow;
            }
            elt.edit = false;
            temp.push(elt);
          });
          this.listNomenclature = temp;
          this.listNomenclature = [...this.listNomenclature];
        }
        console.log(this.listNomenclature);
        this.showFormEdit({});
      } else {
        this.erreur = 'Il faut sélectionner un article';
        this.common.openModal(this.modalService, this.msg);
        return false;
      }
    }
  }

  resetEdit() {
    this.listNomenclature.forEach(elt => {
      elt.edit = false;
    });
  }

  getListNomenclature() {
    this.detail['nomclass'] = 'Client';
    const param = {
      'servlet': 'DBNomenclatureNeg',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'CLEF_CLIENT': {
          'typeParam': 'int',
          'valeur': this.detail['id']
        }
      }
    };

    return this.common.post('', { param: param }).then(datas => {
      $('#empty').trigger('click');
      this.listNomenclature = datas.data || [];
      this.listNomenclature.forEach(elt => this.getLibelleContenant(elt.typeContenant));
      return datas.data;
    });
  }

  selectRow(row) {
    this.focusIndex = this.listNomenclature.indexOf(row);
    this.selected = [row];
  }

  inserteLigne() {
    this.listNomenclature.splice(this.focusIndex, 0, {
      id: '1', dateDebut: moment().format('DD/MM/YYYY HH:mm:ss'),
      dateFin: '31/12/9999'
    });
    const ctrl = this;
    setTimeout(function () {
      $('.article' + (ctrl.focusIndex)).focus();
    }, 600);
  }

  deleteLigne(row, index) {
    this.listNomenclature = this.listNomenclature.filter(elt => elt !== row);
    this.listNomenclature = [... this.listNomenclature]
  }

  addLigne() {
    this.listNomenclature.push({
      index: this.listNomenclature.length, id: '1',
      dateDebut: moment().format('DD/MM/YYYY HH:mm:ss'), dateFin: '31/12/9999'
    });
    this.listNomenclature = [...this.listNomenclature];
    const length = this.listNomenclature.length - 1;
    setTimeout(function () {
      $('.article' + (length)).focus();
    }, 600);
  }

  searchArticle(event) {
    this.dataArticle = [];
    const param = 2;

    return this.common.appelComboK3Fct(param, event).then(datas => {
      // $('#autocomplete').trigger('click');
      if (datas.data) {
        this.dataArticle = datas.data;
      } else {
        if (datas.message) {
          if (datas.message.includes('Utilisateur non authentifié')) {
            this.common.removeConnection();
          }
        }
      }
    });
  }

  setValue(event, row?) {
    this.checkFamilleArt(event.id);
    this.setArticle(event);
  }

  checkFamilleArt(id) {
    const param = {
      'servlet': 'DBCheckFamilleArticle',
      'module': 'Recylog',
      'type': 'objet',
      'compression': 'false',
      'data': {
        'typeParam': 'string',
        'valeur': id
      }
    };
    return this.common.post('', { param: param }).then(datas => {
      const data = datas.data;
      this.isFamille2 = data.length && data[0] === 2 ? true : false;
      return datas.data;
    });
  }

  searchChantier(event) {
    this.listChantier = [{ id: 0, libelleObjetEntite: 'Tous' }];
    const param = {
      'servlet': 'DBGetChantierClient',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {

        'SITE': {
          'typeParam': 'int',
          'valeur': this.common.user[2]
        },
        'CLEF_CLIENT': {
          'typeParam': 'int',
          'valeur': this.detail['id']
        },
        'CRITERE': event || ''
      }
    };

    return this.common.post('', { param: param }).then(datas => {
      // $('#autocomplete').trigger('click');
      if (this.common.verifySession(datas)) {
        this.listChantier = [...this.listChantier, ...datas.data];
      }
    });
  }

  getListeAgence(event?) {
    this.listeAgence = [{ id: 0, libelleObjetEntite: 'Toutes' }];
    const param = {
      'servlet': 'DBAgenceGet',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'CLEF_CLIENT': {
          'typeParam': 'int',
          'valeur': this.detail['id']
        },
        'CRITERE': event || ''
      }
    };

    return this.common.post('', { param: param }).then(datas => {
      // $('#autocomplete').trigger('click');
      if (this.common.verifySession(datas)) {
        this.listeAgence = [...this.listeAgence, ...datas.data];
      }
    });
  }

  searchArticleContenu(event) {
    this.artContenu = [];
    const param = 3;

    return this.common.appelComboK3Fct(param, event).then(datas => {
      // $('#autocomplete').trigger('click');
      if (datas.data) {
        this.artContenu = [...[{ id: 0, libelle: 'Tous', libelleObjetEntite: 'Tous' }], ...datas.data || []];
      } else {
        if (datas.message) {
          if (datas.message.includes('Utilisateur non authentifié')) {
            this.common.removeConnection();
          }
        }
      }
    });
  }

  searchTypecontenant() {
    this.typeContenant = [{ id: 0, libelleObjetEntite: 'Tous' }];
    this.common.getType('listetypeContenant').forEach(elt => {
      elt.libelleObjetEntite = (elt.famille ? elt.famille.libelle + ' ' : '') + (elt.cubage ? elt.cubage.cubage + ' ' : '') +
        (elt.uniteCont ? elt.uniteCont.libelle : '');
      this.typeContenant.push(elt);
    });
  }

  searchExutoire(event) {
    const param = 6;

    return this.common.appelComboK3Fct(param, event).then(datas => {
      // $('#autocomplete').trigger('click');
      if (this.common.verifySession(datas)) {
        const l = [{ id: 0, libelleObjetEntite: 'Tous' }];
        l.push(...datas.data);
        this.listExutoire = l;
      }
    });
  }

  focus(event) {
    const input = event.target;
    const originalValue = $(input).val();
    $(input).val('');
    $(input).blur().focus().val(originalValue);
  }

  calculMontant(row) {
    if (row.qte && row.tarif) {
      row.prixHT = row.qte * row.tarif;
    } else {
      row.prixHT = 0;
    }
  }

  saveNomenclatureNego() {
    this.listNomenclature.forEach(elt => elt.nomclass = 'Article');
    const param = {
      'servlet': 'DBNomenclatureNeg',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'CLEF_CLIENT': {
          'typeParam': 'int',
          'valeur': this.detail['id']
        },
        'LIST_NOM_NEG': this.listNomenclature
      }
    };

    return this.common.post('', { param: param }).then(datas => {
      this.hide();
    });
  }

  getLibelleContenant(elt) {
    if (elt) {
      elt.libelleObjetEntite = (elt.famille ? elt.famille.libelle + ' ' : '') + (elt.cubage ? elt.cubage.cubage + ' ' : '') +
        (elt.uniteCont ? elt.uniteCont.libelle : '');
    }
  }

  addLigneDetail() {
    this.selectedRow.listArtNomenclature = this.selectedRow.listArtNomenclature || [];
    this.selectedRow.listArtNomenclature.push({});
    this.selectedRow.listArtNomenclature = [...this.selectedRow.listArtNomenclature];
    const ctrl = this;
    setTimeout(function () {
      const elem = $('datatable-scroller:last-child')[0].lastElementChild;
      $('.articleListe' + (ctrl.selectedRow.listArtNomenclature.length - 1)).focus();
    }, 600);
  }

  deleteLigneDetail(row) {
    const temp = this.selectedRow.listArtNomenclature.filter(elt => elt !== row);
    this.selectedRow.listArtNomenclature = temp;
    const ctrl = this;
    setTimeout(function () {
      if ($('datatable-scroller:last-child') && $('datatable-scroller:last-child')[0]) {
        const elem = $('datatable-scroller:last-child')[0].lastElementChild;
        $('.articleListe' + (ctrl.selectedRow.listArtNomenclature.length - 1)).focus();
      }
    }, 600);
  }

  setArticle(event, list?) {
    this.getDetailArticle(event.id).then(data => {
      const article = data[0];
      if (!list) {
        this.selectedRow['id'] = event.id;
        this.selectedRow['code'] = article.code;
        this.selectedRow['libelle'] = article.libelle;
        this.selectedRow['libelleObjetEntite'] = article.libelle;
      } else {
        list['id'] = event.id;
        list['code'] = article.code;
        list['libelle'] = article.libelle;
        list['libelleObjetEntite'] = article.libelle;
      }
    });
  }

  getDetailArticle(id) {
    const clef = '' + id;
    const param = {
      'servlet': 'DBGetArticle',
      'module': 'Recylog',
      'type': 'tableau',
      'compression': 'false',
      'data': ['DBGetArticle', clef]
    };
    return this.common.post('', { param: param }).then(datas => {
      return datas.data;
    });
  }

}
